module.exports = __webpack_public_path__ + "img/mobile-wish-outline.64636eb.svg?v=1764823240413";